import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
import { Button } from '../ui/Button';
export function WRHero() {
  return <section className="relative pt-[120px] pb-[60px] lg:pt-[160px] lg:pb-[100px] overflow-hidden min-h-[500px] lg:min-h-[70vh] flex items-center" data-id="element-2336">
      {/* Background Image */}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/cTSobxDp2RiPc9MDYeSFJE/wrinkle-relaxers.jpg)'
    }} data-id="element-2337" />
      {/* Dark overlay for text readability */}
      <div className="absolute inset-0 bg-black/60" data-id="element-2338" />

      <div className="max-w-[1200px] mx-auto px-6 lg:px-8 w-full relative z-10" data-id="element-2339">
        <AnimateOnScroll className="w-full lg:w-[60%]" data-id="element-2340">
          <div className="mb-6" data-id="element-2341">
            <span className="text-[#999999] text-[13px] font-body" data-id="element-2342">
              <a href="/treatments" className="hover:text-[#FF1493] transition-colors" data-id="element-2343">
                Treatments
              </a>{' '}
              / Injectables
            </span>
          </div>

          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-4 block font-[Poppins,_sans-serif]" data-id="element-2344">
            Be UNEXPECTED
          </span>

          <h1 className="text-[32px] sm:text-5xl lg:text-[64px] uppercase text-white tracking-tight mb-2 font-[600] font-[Poppins,_sans-serif] leading-none" data-id="element-2345">
            WRINKLE RELAXERS
          </h1>

          <p className="font-serif italic text-white/80 text-xl lg:text-2xl mb-8" data-id="element-2346">
            in a nutshell
          </p>

          <div className="space-y-6" data-id="element-2347">
            <p className="text-[#D0D0D0] text-[17px] leading-[1.7] font-body" data-id="element-2348">
              <span className="italic" data-id="element-2349">
                "'Prevention, prevention, prevention!' When it comes to using
                wrinkle relaxers, Dr. Fiona says, 'it's much easier for us to
                prevent fine lines and wrinkles than remove them.'"
              </span>
            </p>

            <p className="text-[#D0D0D0] text-base leading-[1.7] font-body" data-id="element-2350">
              For natural looking results and a refreshed, rejuvenated
              appearance, injectables can do amazing things! At Be CLINICAL, we
              offer wrinkle relaxers including Botox, Dysport and Xeomin.
            </p>
          </div>

          <Button variant="primary" size="lg" className="mt-8 w-full sm:w-auto" data-id="element-2351">
            SCHEDULE CONSULTATION
          </Button>
        </AnimateOnScroll>
      </div>
    </section>;
}